import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../../Component/Topbar/Topbar";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { get, post } from "../../redux/api/ApiHandler";
import { URLS } from "../../redux/api/Constants";
import toast from "react-hot-toast";
import { userDetails } from "../../../Component/userDetails";

const SuperAdminAdd = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const formType = location.state?.type; // "add" | "edit" | "view"
  const existingData = location.state?.data; // Prefill for edit/view
  const isViewMode = formType === "view";
  const isaddMode = formType === "add";
  const isEditMode = formType === "edit";
  const id = location?.state?.id;
  const users = localStorage.getItem("user");
  const parsedMobile = users ? JSON.parse(users) : null;
  const userMobile = parsedMobile?.mobile || "";
  const mobile = location?.state?.mobile;
  const type = location?.state?.type;

  console.log("mobile", userMobile, mobile);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const togglePassword = () => setShowPassword(!showPassword);
  const toggleConfirmPassword = () => setShowConfirm(!showConfirm);

  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      employeeId: "",
      employeeName: "",
      email: "",
      mobile: "",
      role: "Super Admin",
      password: "",
      confirmPassword: "",
    },
  });

  const addAdmin = async () => {
    const values = getValues(); // 👈 get all form field values

    let payload = {
      name: values.employeeName,
      mobile: values.mobile,
      email: values.email,
      ...(values.password && {
        password: values.password,
      }),
      role: 1,
      code: values.employeeId,
      parent_id: 10,
      region_id: 3,
      status: 1,
    };
    if (type == "add") {
      let res = await post(URLS.ADMINADD, payload);
      if (res?.status == "success") {
        toast.success(res?.message);
        navigate("/super-admin");
      }
    } else {
      let res = await post(URLS.ADMINEDIT + id, payload);
      if (res?.status == "success") {
        toast.success(res?.message);
        navigate("/super-admin");
      }
    }
    console.log("Payload:", payload);
  };

  const viewAdmin = async () => {
    let res = await get(URLS.ADMINVIEW + id);

    if (res?.status === "success" && res?.data) {
      const admin = res.data;
      setValue("employeeId", admin.code || "");
      setValue("employeeName", admin.name || "");
      setValue("email", admin.email || "");
      setValue("mobile", admin.mobile || "");
      setValue("role", admin.role == 1 ? "Super Admin" : "");
    }
  };

  useEffect(() => {
    if (type != "add") {
      viewAdmin();
    }
  }, []);

  // const dummyData = {
  //   employeeId: "123",
  //   employeeName: "Surya",
  //   email: "surya@gmail.com",
  //   mobile: "9876543210",
  //   role: "Super Admin",
  //   password: "password123",
  //   confirmPassword: "password123"
  // };

  // useEffect(() => {
  //   if (isViewMode || isEditMode) {
  //     const dataToUse = dummyData;
  //     Object.entries(dataToUse).forEach(([key, value]) => {
  //       setValue(key, value);
  //     });
  //     setValue("confirmPassword", dataToUse.password);
  //   }
  // }, [isViewMode, isEditMode, setValue]);

  const onSubmit = (data) => {
    addAdmin(data);
    console.log("Submitted Data:", data);

    if (isEditMode) {
      console.log("Updating user...");
    } else {
      console.log("Adding new user...");
    }
  };

  const passwordValue = watch("password");

  return (
    <div>
      <Topbar
        header="Super Admin"
        subHead={isViewMode ? "View" : isEditMode ? "Edit" : "Add"}
      />
      <div className="container_fluit1 px-4 py-3">
        <form
          className="d-flex flex-wrap gap-5"
          onSubmit={handleSubmit(onSubmit)}
        >
          {/* Employee ID */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="employeeId"
              rules={{ required: "Employee ID is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Employee ID <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Employee ID"
                    disabled={isViewMode || isEditMode}
                  />
                  {errors.employeeId && (
                    <p style={{ color: "red" }}>{errors.employeeId.message}</p>
                  )}
                </div>
              )}
            />
          </div>

          {/* Employee Name */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="employeeName"
              rules={{ required: "Employee Name is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Employee Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Employee Name"
                    disabled={isViewMode}
                  />
                  {errors.employeeName && (
                    <p style={{ color: "red" }}>
                      {errors.employeeName.message}
                    </p>
                  )}
                </div>
              )}
            />
          </div>

          {/* Email */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="email"
              rules={{
                required: "Email is required",
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Invalid email format",
                },
              }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Email <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    type="email"
                    className="input-box"
                    placeholder="Enter Email"
                    disabled={isViewMode}
                  />
                  {errors.email && (
                    <p style={{ color: "red" }}>{errors.email.message}</p>
                  )}
                </div>
              )}
            />
          </div>

          {/* Mobile */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="mobile"
              rules={{
                required: "Mobile number is required",
                pattern: {
                  value: /^[6-9]\d{9}$/,
                  message: "Enter a valid Indian mobile number",
                },
              }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Mobile Number <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="number"
                    {...field}
                    onInput={(e) =>
                      (e.target.value = e.target.value.slice(0, 10))
                    }
                    className="input-box"
                    placeholder="Enter Mobile Number"
                    disabled={isViewMode}
                  />
                  {errors.mobile && (
                    <p style={{ color: "red" }}>{errors.mobile.message}</p>
                  )}
                </div>
              )}
            />
          </div>

          {/* Role */}
          <div className="col-md-5">
            <Controller
              control={control}
              name="role"
              rules={{ required: "Role is required" }}
              render={({ field }) => (
                <div>
                  <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                    Role <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    {...field}
                    className="input-box"
                    placeholder="Enter Role"
                    // disabled={isViewMode}
                    disabled
                  />
                  {errors.role && (
                    <p style={{ color: "red" }}>{errors.role.message}</p>
                  )}
                </div>
              )}
            />
          </div>

          {/* Password */}
          {!isViewMode && (
            <>
              {/* Password */}
              <div className="col-md-5">
                <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                  Password{" "}
                  {!isEditMode && <span style={{ color: "red" }}>*</span>}
                  {isEditMode && (
                    <span className="text-muted" style={{ fontSize: "13px" }}>
                      {" "}
                      (Optional)
                    </span>
                  )}
                </label>

                <Controller
                  control={control}
                  name="password"
                  rules={
                    isEditMode
                      ? {
                          minLength: {
                            value: 6,
                            message: "Password must be at least 6 characters",
                          },
                        }
                      : {
                          required: "Password is required",
                          minLength: {
                            value: 6,
                            message: "Password must be at least 6 characters",
                          },
                        }
                  }
                  render={({ field }) => (
                    <div className="password-input d-flex align-items-center">
                      <input
                        {...field}
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        placeholder="Enter Password"
                      />
                      <span
                        onClick={togglePassword}
                        className="password_color"
                        style={{ cursor: "pointer", padding: "8px" }}
                      >
                        {showPassword ? (
                          <VisibilityIcon />
                        ) : (
                          <VisibilityOffIcon />
                        )}
                      </span>
                    </div>
                  )}
                />
                {errors.password && (
                  <p style={{ color: "red" }}>{errors.password.message}</p>
                )}
              </div>

              <div className="col-md-5"></div>

              {/* Confirm Password */}
              <div className="col-md-5">
                <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                  Confirm Password{" "}
                  {!isEditMode && <span style={{ color: "red" }}>*</span>}
                </label>

                <Controller
                  control={control}
                  name="confirmPassword"
                  rules={
                    isEditMode
                      ? {
                          validate: (value) =>
                            !value ||
                            value === passwordValue ||
                            "Passwords do not match",
                        }
                      : {
                          required: "Confirm Password is required",
                          validate: (value) =>
                            value === passwordValue || "Passwords do not match",
                        }
                  }
                  render={({ field }) => (
                    <div className="password-input d-flex align-items-center">
                      <input
                        {...field}
                        type={showConfirm ? "text" : "password"}
                        className="form-control"
                        placeholder="Confirm Password"
                      />
                      <span
                        className="password_color"
                        onClick={toggleConfirmPassword}
                        style={{ cursor: "pointer", padding: "8px" }}
                      >
                        {showConfirm ? (
                          <VisibilityIcon />
                        ) : (
                          <VisibilityOffIcon />
                        )}
                      </span>
                    </div>
                  )}
                />
                {errors.confirmPassword && (
                  <p style={{ color: "red" }}>
                    {errors.confirmPassword.message}
                  </p>
                )}
              </div>
            </>
          )}
        </form>

        {/* Buttons */}
        <div className="d-flex col-md-11 ac-jb mt-5">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="back_btn f2 fs-sm-15 fs-md-15 fs-lg-2=17 fs-xl-18 fs-xxl-20"
          >
            Back
          </button>
          {!isViewMode && (
            <button
              type="submit"
              onClick={handleSubmit(onSubmit)}
              className="Add_btn f2 fs-sm-15 fs-md-15 fs-lg-2=17 fs-xl-18 fs-xxl-20"
            >
              {isEditMode ? "Save" : "Submit"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SuperAdminAdd;
